import type { AxiosInstance } from 'axios'
import type { Notifier } from '~/shared/interfaces'
import { initializeServices } from '~/services'
import { useNotificationsStore } from '~/store/notifications'
import { getHosts } from '~/shared/utils/env'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const hosts = getHosts({
    NUXT_PUBLIC_ENVIRONMENT_STAND: config.public.environmentStand,
  })

  const notifier: Notifier = {
    showError: (message) => {
      if (import.meta.client) {
        useNotificationsStore().setError(message)
      }
    },
  }

  nuxtApp.provide(
    'services',
    initializeServices({
      axiosInstance: nuxtApp.$axios as AxiosInstance,
      notifier,
      tokenManager: useUserToken(),
      authHost: hosts.authHost,
      dadataBaseUri: config.public.dadataBaseUri,
    })
  )
})
